import * as ActionType from "./staff.type";

const initialState = {
  staff: [],
  totalStaff: 0,
  isLoading: false,
};

export const staffReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_STAFF:
      return {
        ...state,
        staff: action.payload.data,
        totalStaff: action.payload.total,
      };
    case ActionType.CREATE_STAFF:
      return {
        ...state,
        staff: [action.payload, ...state.staff],
        totalStaff: state.totalStaff + 1,
      };
    case ActionType.EDIT_STAFF:
      return {
        ...state,
        staff: state.staff.map((s) =>
          s._id === action.payload._id ? action.payload : s
        ),
      };
    case ActionType.DELETE_STAFF:
      return {
        ...state,
        staff: state.staff.filter((s) => s._id !== action.payload),
        totalStaff: state.totalStaff - 1,
      };
    case ActionType.UPDATE_STAFF_STATUS:
      return {
        ...state,
        staff: state.staff.map((s) =>
          s._id === action.payload ? { ...s, isActive: !s.isActive } : 
          (s._id === action.payload._id ? action.payload : s)
        ),
      };
    default:
      return state;
  }
};
